export default __webpack_public_path__ + "static/media/LineosoftArticleListing3-min.ddd44d19.PNG";